<crm-single-select
  [options]="activities"
  [(selectedItem)]="selectedActivity"
  (selectedItemChange)="selectedActivityChange.emit($event)"
  (changeValue)="changeValue.emit($event)"
  [showClear]="showClear"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [appendTo]="appendTo"
  [disabled]="disabled"
  [loading]="loading">
</crm-single-select>
